import { produce } from 'immer';

import { CHATTEL_DETAILS_ACTION_TYPE } from '../actions/chattelDetails.actions';

const initialState = {
  details: null,
};

const chattelDetailsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case CHATTEL_DETAILS_ACTION_TYPE.GET_CHATTEL_DETAILS:
      case CHATTEL_DETAILS_ACTION_TYPE.UPDATE_CHATTEL_DETAILS:
        draft.details = payload;
        break;

      default:
        break;
    }
  });

export default chattelDetailsReducer;
